//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"CreationMethod",1,0]],[[["startAngle","incrementAngle","numberOfPlanes"],"SetPlanesAtAngles",{},3,0],[["points","incrementAngle","numberOfPlanes"],"SetPlanesThroughPoints",{},3,0],[["count","startAngle","incrementAngle","numberOfPlanes"],"GetPlanesAtAngles",{},0,0],[["count","points","incrementAngle","numberOfPlanes"],"GetPlanesThroughPoints",{},0,0],[[],"Generate",{R_:{success:''}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.CAM.SpunOutlineGeom = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.SpunOutlineGeom";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.SpunOutlineGeom.CreationTypes = Object.freeze({
    "Automatic" : "Automatic", "PlanesAtAngles" : "PlanesAtAngles", "PlanesThroughPoints" : "PlanesThroughPoints", "SameAsPart" : "SameAsPart", "None" : "None"});

export default SPLM;